import { useContext } from "react"
import { Text } from "@planningcenter/tapestry-react"
import RegisterableContext from "components/admin/registerable/context"
import { isPresent } from "utils/helpers"
import { formatDateTimeShort } from "utils/dates"
import { colors } from "components/shared/admin_colors"

const MetaInformation = () => {
  const { registerable } = useContext(RegisterableContext)

  return (
    <Text size={4} color={colors.neutral_020}>
      Registered on {formatDateTimeShort(registerable.createdAt)}
      {isPresent(registerable.createdByName) ? ` by ${registerable.createdByName}` : ""}
      {registerable.isCanceled && (
        <div className="mt-4p">Canceled on {formatDateTimeShort(registerable.canceledOn)}</div>
      )}
    </Text>
  )
}

export default MetaInformation
